












































































































































































































































import { defineComponent, ref, watch, computed } from '@vue/composition-api';
import { getDoctorInfoStorage, mosaicIdCard } from '@/utils/utils';
import { PatientItem } from '@/types/type';
import { queryDepartment, apiQueryPermDoctorList, getWaitConfirmPatientList } from '@/formQuestionnaire/services';
import { DepartmentItem, DoctorItem, GroupItem, PatientQuery } from '@/formQuestionnaire/type/type';
import { PatientToBeDetermined, METHOD_OF_JOIN_LIST, PatientSource } from '@/formQuestionnaire/business';
import pagination from '@/formQuestionnaire/pagination.vue';
import { getPatients, getInHospitalPatientList } from '@/views/inHospitalDataModule/api/api';
import { queryPatientList, getGroup, querySearchGroupList, getPermDepartmentList } from '@/services/user/index';
import { DoctorInfo } from '@/components/type/type';
import multipleSelect from '@/components/multipleSelect.vue';
import { getHospitalValue } from '@/config/hospital';
import doctorGroupHooks from '@/views/patient/hooks/doctorGroup';
export default defineComponent({
  components: {
    pagination,
    multipleSelect,
  },
  model: {
    prop: 'show',
    event: 'change',
  },
  props: {
    show: Boolean,
    groupMsg: String,
    defaultInviteDocument: {
      type: String,
      default: '',
    },
    importPatientsType: {
      type: Number,
      default: PatientToBeDetermined.noTask,
    },
    selectedPatient: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, { root, emit }: any) {
    const isJiayi = computed(() => root.$store.state.organType === 3); // 选中患者列表
    const importStep = ref(0);
    const visitTable = ref(null);
    const searchInput = ref(null);
    const departOptions = ref<DepartmentItem[]>([]);
    const searchFocused = ref(false);
    const doctorOptions = ref<DoctorItem[]>([]);
    const historyWords = ref<string[]>([]);
    const msg = ref('');
    const hospitalId = ref(0);
    const patientType = ref<PatientSource>(isJiayi.value ? PatientSource.innerHospital : PatientSource.outerHospital);
    const loading = ref(true);
    const importPatientList = ref<PatientItem[]>([]);
    const importCount = ref(0);
    const groupList = ref<GroupItem[]>([]);
    const { followUpId } = root.$route.query;

    // eslint-disable-next-line max-len
    const {
      doctorGroupOptions,
      doctorGroupId,
      computedDoctorGroupId,
      doctorGroupMultipleSelect,
      getDoctorGroup,
      tagOptions,
      tagId,
      computedTagId,
      tagMultipleSelect,
      getTag,
    } = doctorGroupHooks();
    if (isJiayi.value) {
      getDoctorGroup();
      getTag();
    }
    const query = ref<PatientQuery>({
      currentPage: 0,
      departmentId: [],
      doctorId: [],
      followUpId,
      key: '',
      pageSize: 10,
      programName: '',
      source: 'followUpImport',
      groupIdList: [],
      doctorGroupId: '',
      jyTagIds: '',
      opType: 1,
      systemTags: [],
      customTags: [],
    });
    const doctorInfo = ref<DoctorInfo>(getDoctorInfoStorage());

    const importSelectList = computed<PatientItem[]>(() => root.$store.state.importSelectList);

    const computedShow = computed({
      get() {
        return props.show;
      },
      set() {
        emit('change', false);
      },
    });

    const computedDepartmentId = computed(() => {
      const departmentId = query.value.departmentId;
      return departmentId.includes('') ? '' : departmentId.join(',');
    });

    const patientRegisterName = computed(() => getHospitalValue(hospitalId.value, 'patientRegisterName'));

    const queryPatients = async () => {
      const { importPatientsType } = props;
      const { currentPage, pageSize, key, groupIdList, departmentId, doctorId } = query.value;
      const doctorIdValue = doctorId.includes('') ? '' : doctorId.join(',');
      const groupIdListValue = groupIdList.includes('') ? [] : groupIdList;
      if (importPatientsType === PatientToBeDetermined.noTask) {
        if (patientType.value === PatientSource.innerHospital) {
          const departmentIdList = departmentId.includes('') ? [] : departmentId;
          const doctorIdList = doctorId.includes('') ? [] : doctorId;
          let name = '';
          let patientRegisterNo = '';
          if (/[\u4e00-\u9fa5]+/g.test(key)) {
            name = key;
            patientRegisterNo = '';
          } else {
            name = '';
            patientRegisterNo = key;
          }
          const innerParams = {
            departmentIdList,
            doctorIdList,
            pageIndex: currentPage || 0,
            pageSize,
            name,
            patientRegisterNo,
            groupIdList: groupIdListValue,
            doctorGroupId: computedDoctorGroupId.value,
            jyTagIds: computedTagId.value,
          };
          const { patients = [], count = 0 } = isJiayi.value
            ? await getInHospitalPatientList(innerParams)
            : await getPatients(innerParams);
          patients.forEach((item) => {
            item.patientName = item.name;
            item.patientAge = item.age;
            item.patientGender = item.gender;
            item.patientIdCard = item.idCard;
            item.groupIds = item.groups;
          });
          importPatientList.value = patients;
          importCount.value = count;
        } else {
          const params = {
            ...query.value,
            departmentId: computedDepartmentId.value,
            doctorId: doctorIdValue,
            groupIdList: groupIdListValue,
          };
          const { patientList = [], totalCounts = 0 } = await queryPatientList(params);
          importPatientList.value = patientList;
          importCount.value = totalCounts;
        }
      } else {
        const { patientList = [], totalCount = 0 } = await getWaitConfirmPatientList({
          currentPage,
          type: importPatientsType,
          pageSize,
          departmentId: computedDepartmentId.value,
          doctorId: doctorIdValue,
          groupId: '',
          followUpId,
          key,
        });
        importPatientList.value = patientList;
        importCount.value = Number(totalCount);
      }
      loading.value = false;
    };

    const closePop = () => {
      computedShow.value = false;
    };

    const searchKey = (k = '') => {
      if (k) {
        query.value.key = k;
        searchFocused.value = false;
      }
      const keyValue = query.value.key;
      (searchInput.value as any)?.blur?.();
      query.value.currentPage = 0;
      queryPatients();
      const historyWordsValue = historyWords.value;
      if (historyWordsValue.indexOf(keyValue) === -1 && keyValue) {
        historyWordsValue.push(keyValue);
        let storageList = historyWordsValue;
        if (historyWordsValue.length > 5) {
          storageList = historyWordsValue.slice(historyWordsValue.length - 5, historyWordsValue.length);
          historyWords.value = storageList;
        }
        window.localStorage.setItem('visitImportHistoryWords', JSON.stringify(storageList));
      }
    };

    const getRowKeys = (row: PatientItem) => row.patientId;

    const searchFocus = () => {
      searchFocused.value = true;
    };

    // 获取科室列表
    const getDepartment = async () => {
      const isHasTask = props.importPatientsType !== PatientToBeDetermined.noTask;
      const isInHospital = patientType.value === PatientSource.innerHospital || isHasTask;
      const fn = isInHospital ? queryDepartment : getPermDepartmentList;
      const { departmentList } = await fn();
      departOptions.value = departmentList;
      query.value.departmentId = departmentList.map(item => item.departmentId);
    };

    // 获取该科室下的医生列表
    const queryDoctor = async () => {
      const { doctorList } = await apiQueryPermDoctorList(computedDepartmentId.value);
      doctorOptions.value = doctorList;
      query.value.doctorId = doctorList.map(item => item.doctorId);
    };

    const paramsInit = () => {
      doctorInfo.value = getDoctorInfoStorage();
      hospitalId.value = doctorInfo.value.hospitalId;
      msg.value = props.defaultInviteDocument;
      if (window.localStorage.getItem('visitImportHistoryWords')) {
        historyWords.value = JSON.parse(window.localStorage.getItem('visitImportHistoryWords') || '').filter(e => e !== '');
      }
    };

    const radio = ref('');
    const currentPatient = ref<any>({});
    const handleCurrentChange = (currentRow) => {
      radio.value = currentRow?.patientId || '';
      const { patientId, patientName, patientAge, patientGender } = currentRow;
      currentPatient.value = {
        patientId,
        patientName,
        patientAge,
        patientGender,
      };
    };
    const confirm = () => {
      emit('confirm', currentPatient.value);
      computedShow.value = false;
    };

    const reset = () => {
      query.value = {
        ...query.value,
        currentPage: 0,
        departmentId: [],
        doctorId: [],
        groupIdList: [],
        key: '',
        pageSize: 10,
        programName: '',
        doctorGroupId: '',
        jyTagIds: '',
        opType: 1,
        systemTags: [],
        customTags: [],
      };
      tagSelectedList.value = [];
    };

    const searchBlur = () => {
      setTimeout(() => {
        searchFocused.value = false;
      }, 500);
    };
    let isInit = false;

    // 科室选择
    const departmentChange = async (list: string[]) => {
      query.value.departmentId = list;
      if (list.length && !isInit) {
        query.value.doctorId = [];
        await queryDoctor();
      }
    };
    const doctorGroupChange = async (list: string[]) => {
      doctorGroupMultipleSelect(list);
      console.log('doctorGroupChange');
      queryPatients();
    };
    const tagChange = async (list: string[]) => {
      tagMultipleSelect(list);
      console.log('tagChange');
      queryPatients();
    };

    const groupIdChange = async (list: string[]) => {
      query.value.groupIdList = list;
      if (list.length && !isInit) {
        console.log('groupIdChange', list);
        queryPatients();
      }
    };

    // 医生选择
    const doctorIdChange = (list: string[]) => {
      query.value.doctorId = list;
      if (list.length && !isInit) {
        console.log('doctorIdChange');
        queryPatients();
      }
    };

    // 分组选择
    const groupChange = (list: number[]) => {
      query.value.groupIdList = list;
      if (list.length && !isInit) {
        console.log('groupChange');
        queryPatients();
      }
    };

    // 获取分组
    const requestGroup = async () => {
      let groupListValue: any = [];
      if (patientType.value === PatientSource.innerHospital) {
        const res = await getGroup();
        groupListValue = res?.groups || [];
      } else {
        const res = await querySearchGroupList();
        const list = res?.groupList || [];
        list.forEach((item) => {
          item.groupId = item.id;
        });
        groupListValue = list;
      }
      groupList.value = groupListValue;
      query.value.groupIdList = groupListValue.map(item => item.groupId);
    };

    const tagFilterDialogShow = ref(false);
    const tagSelectedList = ref([]);

    const init = async () => {
      isInit = true;
      console.log('init query');
      Promise.all([getDepartment(), queryDoctor(), requestGroup(), queryPatients()]).then(() => {
        isInit = false;
      });
    };
    paramsInit();

    watch(
      () => props.show,
      (newValue: boolean) => {
        if (newValue) {
          radio.value = props.selectedPatient.patientId;
          currentPatient.value = props.selectedPatient;

          init();
        } else {
          reset();
        }
        importStep.value = 0;
      },
    );

    watch(
      () => patientType.value,
      () => {
        loading.value = true;
        reset();
        init();
      },
    );

    return {
      patientType,
      METHOD_OF_JOIN_LIST,
      importStep,
      visitTable,
      getRowKeys,
      searchFocus,
      departOptions,
      searchKey,
      searchBlur,
      searchFocused,
      doctorOptions,
      historyWords,
      importCount,
      importSelectList,
      closePop,
      confirm,
      loading,
      importPatientList,
      msg,
      mosaicIdCard,
      PatientToBeDetermined,
      departmentChange,
      doctorIdChange,
      queryPatients,
      query,
      groupList,
      groupChange,
      computedShow,
      doctorInfo,
      PatientSource,
      patientRegisterName,
      isJiayi,
      doctorGroupOptions,
      doctorGroupId,
      doctorGroupMultipleSelect,
      doctorGroupChange,
      tagOptions,
      tagId,
      tagMultipleSelect,
      tagChange,
      tagFilterDialogShow,
      tagSelectedList,
      handleCurrentChange,
      radio,
      currentPatient,
      groupIdChange,
    };
  },
});
